@import "../../../../shared/scss";

:host {
  background-color: $pds-theme-light-background-base;
  position: fixed;
  inset-block-start: 0;
  translate: calc(var(--isLTR, 1) * -1000px);
  block-size: 100vh;
  z-index: $phn-z-index-mega-flyout + 1;
  inline-size: 65%;
  // prevent the drawer from being taken into account by underlying blur from pds-frosted-glass
  backdrop-filter: blur(0px);
  -webkit-backdrop-filter: blur(0px);

  @include pds-media-query-min("s") {
    inline-size: 85%;
  }

  @include pds-media-query-min("m") {
    inline-size: 65%;
  }

  @include pds-media-query-min("l") {
    translate: calc(var(--isLTR, 1) * -1300px);
  }

  @include pds-media-query-min("xxl") {
    max-inline-size: p-px-to-rem(1248px);
    translate: calc(var(--isLTR, 1) * -1350px);
  }

  &.opening-animation {
    translate: 0px;
    @media (prefers-reduced-motion: no-preference) {
      transition: translate $pds-motion-duration-long $pds-motion-easing-in;
    }
  }

  &.closing-animation {
    translate: calc(var(--isLTR, 1) * -1000px);
    @media (prefers-reduced-motion: no-preference) {
      transition: translate $pds-motion-duration-long $pds-motion-easing-out;
    }

    @include pds-media-query-min("l") {
      translate: calc(var(--isLTR, 1) * -1300px);
    }

    @include pds-media-query-min("xxl") {
      translate: calc(var(--isLTR, 1) * -1350px);
    }
  }

  .close-button {
    position: absolute;
    inset-inline-end: p-px-to-rem(-70px);
    inset-block-start: p-px-to-rem(10px);
    z-index: $phn-z-index-mega-flyout + 1;
  }

  .drawer {
    overflow-y: auto;
    overflow-block: auto;
    overflow-x: hidden;
    overflow-inline: hidden;
    position: relative;
    background-color: $pds-theme-light-background-base;
    block-size: 100vh;
    transition: translate 400ms;

    &#side-drawer {
      z-index: $phn-z-index-mega-flyout + 2;
      float: inline-start;
      inline-size: 40%;
      padding-inline: 5%;

      @media (min-height: 644px) {
        overflow: hidden;
      }

      & > div {
        inset-inline-start: 0;
        block-size: 100%;
        position: relative;
      }

      phn-nd-side-drawer {
        padding-block-end: 6rem;
      }

      .side-drawer-header {
        box-sizing: border-box;
        block-size: p-px-to-rem(92px);
        padding-block-start: p-px-to-rem(42px);

        phn-nd-back-button {
          block-size: p-px-to-rem(24px);
        }
      }
    }

    &#main-drawer {
      z-index: $phn-z-index-mega-flyout + 1;
      float: inline-end;
      background-color: $main-drawer-background-color;
      box-sizing: border-box;
      position: static;
      inline-size: 50%;

      & > div {
        inset-inline-start: 0;
      }

      &:has(phn-nd-models) {
        overflow-y: scroll;
        overflow-block: scroll;
      }

      phn-nd-router:not(:has(phn-nd-car-body-types-drawer)) {
        padding-block-end: 6rem;
      }

      .main-drawer-header {
        opacity: 0;
        box-sizing: border-box;
        block-size: p-px-to-rem(66px);
        padding-block-start: p-px-to-rem(40px);
        margin-block-end: p-px-to-rem(26px);
        inline-size: 100%;
        text-align: center;

        phn-nd-back-button {
          block-size: p-px-to-rem(24px);
        }
      }

      &:has(phn-nd-dealer-details-drawer:not(:empty)) .main-drawer-header,
      &:has(phn-nd-dealer-card:not(:empty)) .main-drawer-header {
        opacity: 1;
        transition: opacity $pds-motion-duration-short $pds-motion-easing-base;
        transition-delay: $pds-motion-duration-short;
      }

      .bottom-gradient {
        z-index: 302;

        @include drawer-gradient(
          rgba(255, 255, 255, 0),
          $main-drawer-background-color
        );
        inline-size: 50%;
        margin-inline-start: 50%;
        border-radius: 0 0 4px 0;
      }
    }
  }
}
